<template>
  <div class="card ride-card">
    <div class="card-body">
      <div class="card-left">
        <div class="card-heading">{{moment(invoice.created_at).format("MM/DD/YY")}}</div>

        <!-- <div class="card-heading">{{(ride.contact_first_name ? ride.contact_first_name : ride.id_rider.name_first) + ' ' + (ride.contact_last_name ? ride.contact_last_name : ride.id_rider.name_last)}}</div> -->
      </div>
      <div class="card-middle">
        <!-- <div class="logo-container" v-bind:style='{ backgroundImage : "url(" + invoice.booking_org.header_url + ")" }'>
        </div> -->
        <span class="org-title card-heading">
          {{ invoice.booking_org.name }}
        </span>        
      </div>
      <div class="card-right">
          <div class="card-heading">${{monthlyTotal}}</div>
      </div>
      <div class="card-expand" v-if="expandable">
          <a :id="'card-toggle-'+invoice.id_invoice"  class="card-toggle-button" href="#" data-action="collapse"><font-awesome-icon icon="angle-right" style="width: 20px; font-size: 1.3rem; margin: 0 10px 0 3px;"/></a>
      </div>
    </div>
    <div class="card-expanded-details " v-bind:class="{ collapse : expandable }">
      <table class="table table-sm full-color-table hover-table">
        <thead>
        <tr style="line-height: 40px">
          <!--<th class="text-center result-label">ID</th>-->
          <th class="result-label">Ride #</th>
          <th class="result-label">Date</th>
          <th class="result-label">Name</th>
          <th class="result-label">To</th>
          <th class="result-label">From</th>
          <th class="result-label">Amount</th>
        </tr>
        </thead>
        <tbody class="col-12">
        <tr v-for="(i, index) in invoiceTransactions" style="line-height: 40px">
          <td class="result-item">
            <div>
              <span>
                {{ i.id_ride.id_alternate ? i.id_ride.id_alternate : i.id_ride.id_ride }}
              </span>
            </div>
          </td>
          <td class="result-item">
            <div>
              <span>
                {{ moment(i.id_ride.date_pickup).format("MM/DD/YY HH:mm") }}
              </span>
            </div>
          </td>
          <td class="result-item">
            <div>
              <span>
                {{(i.id_ride.contact_first_name ? i.id_ride.contact_first_name : i.id_ride.id_rider.name_first) + ' ' + (i.id_ride.contact_last_name ? i.id_ride.contact_last_name : i.id_ride.id_rider.name_last)}}
              </span>
            </div>
          </td>
          <td class="result-item">
            <div>
              <span>
                {{i.id_ride.default_pickup_address}}
              </span>
            </div>
          </td>
          <td class="result-item">
            <div>
              <span>
                {{i.id_ride.default_dropoff_address}}
              </span>
            </div>
          </td>
          <td class="result-item">
            <div>
              <span>
                ${{i.id_ride.price_total}}
              </span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>      



      <div class="ride-details">
        <div class="ride-details-left" style="float:left;">
          <!-- <font-awesome-icon icon="print" style="width: 20px; font-size: 1.3rem; margin: 30px 10px 0 3px; display:inline; color:black;"/> -->
          <span>Billing Contact:</span><br>
          <span>
            {{ invoice.booking_org.billing_contact_name }}
          </span><br>
          <span>
            {{ invoice.booking_org.phone }}
          </span><br>
          <span>
            {{ invoice.booking_org.billing_contact_email }}
          </span><br>

          <a :href="invoice.url"><font-awesome-icon icon="download" style="width: 20px; font-size: 1.3rem; margin: 30px 10px 0 3px; display:inline; color:black;"/></a>

        </div>
        <div class="ride-details-right" style="text-align:right; float: right;">
          <div class="details-body" style="display:inline;">Total Trips: {{monthlyRideCount}}</div>
          <div class="details-price-label">Total Amount ${{monthlyTotal}}</div>

        </div>

      </div>


    </div>
  </div>
  
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'Invoice',
    data () {
      return {
        data: {},
        invoiceTransactions: null,
        showCancelModal: false,
        cancel_id_ride: null,
        cancel_status: null,
      }
    },
    props: {
      invoice : Object,
      ride : Object,
      rides: Array,
      month: String,
      expandable: {
        type: Boolean,
        default: true
      },
      actionable: {
        type: Boolean,
        default: true
      },
    },
    computed: {
      monthlyTotal: function() {
        var total = this.invoice.amount
        return Math.round(total*100)/100
        // return total
      },
      monthlyRideCount: function() {
          if (this.invoiceTransactions) {
              return this.invoiceTransactions.length
          } else {
              return 0
          }
      }

    },      
    methods: {
      checkEventsHasKey: function (events, key) {
        if (!events) return false
        for (let index = 0; index < events.length; index++) {
          if (events[index].id_type_ride_status && events[index].id_type_ride_status.code && events[index].id_type_ride_status.code.includes(key)) {
            return true
          }
        }
        return false
      },
      getEventDateString: function (events, key) {
        if (!events) return false
        for (let index = 0; index < events.length; index++) {
          if (events[index].id_type_ride_status && events[index].id_type_ride_status.code && events[index].id_type_ride_status.code.includes(key)) {
            return moment(events[index].created_at).format("MM/DD/YY HH:mm") + " " + moment.tz(moment.tz.guess()).format('z')
          }
        }
        return 'N/A'
      },

      getInvoiceDetail: function (id_invoice) {
        console.log('>>>' + id_invoice)
        if (!this.invoiceTransactions) {
          this.$http
            .get(process.env.API_BASE_URL + 'cs/transactions/?type=invoice_transactions&page_size=1000&id_invoice=' + id_invoice)
            .then(response => {
              this.invoiceTransactions = response.data.results
              console.log(this.invoiceTransactions)

            })
            .catch(error => {
              this.check403(error);
              if (error.response.status == 401) {
                console.warn("redirect to login")
                this.handle401()
              }
              // console.log(error)
            })
            .finally(() => {})
        }
      },       
    },
    updated () {

    },


    mounted () {

      // $('.card-toggle-button').on('click', function() {
      //   // alert(1)
      // });

      $(function() {
          $('[data-toggle="tooltip"]').tooltip()
      })
      console.log('---')
      $('#card-toggle-'+this.invoice.id_invoice).on('click', (e) => {

          e.preventDefault();
          $(e.target).closest('.card').find('.card-toggle-button').toggleClass('collapse-show');
          // $(e.target).toggleClass('collapse-show');
          $(e.target).closest('.card').children('.card-expanded-details').collapse('toggle');
          if ($(e.target).closest('.card').find('.card-toggle-button').hasClass('collapse-show')) {

            this.getInvoiceDetail(this.invoice.id_invoice);
          }
      });
      // Toggle fullscreen
      $('a[data-action="expand"]').on('click', function(e) {
          e.preventDefault();
          $(this).closest('.card').find('[data-action="expand"] i').toggleClass('mdi-arrow-expand mdi-arrow-compress');
          $(this).closest('.card').toggleClass('card-fullscreen');
      });

      // Close Card
      $('a[data-action="close"]').on('click', function() {
          $(this).closest('.card').removeClass().slideUp('fast');
      });
      if (!this.expandable) {
        this.initMap();
      }
    },
    created () {
      // document.title = "Wingz Support | Driver Dashboard";
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ride-card {
    box-shadow: 0 1px 8px 0 rgb(0 0 0 / 50%);
    border-radius: 1px;
    border: 1px solid #EBEBEB;
    margin-top: 7px;
    margin-left: 3px;
    margin-right: 3px;    
}
.ride-card .card-heading {
    font-size: 20px;
    font-weight: 500;
    color: black;
    word-break: break-word;
    line-height: 28px;
    flex: 1;
}
.ride-card:hover {
    border: 1px solid black;
}
  .card {
    border: 1px solid #EBEBEB;
    
  }
  .card-body {
    display: flex;
    padding: 0px;
    border-color: #EBEBEB;
  }
  .card-body:hover {
    background-color: rgba(0,0,0,0.05);
  }
  .card-body:active {
    background-color: rgba(0,0,0,0.1);
  }  
  .card-body .card-left {
    width: 10%;
    justify-content: center;
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    
    padding: 25px 10px 25px 25px;
    background-color: #EBEBEB;
    border-color: #EBEBEB;
  }
  .card-body .card-middle {
    width: 62%;
    justify-content: flex-start;
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    padding: 25px 25px 25px 40px;
    background-color: #EBEBEB;
    border-color: #EBEBEB;

  }
  .card-body .card-right {
    width: 20%;
    justify-content: center;
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    padding: 25px 0px;
    background-color: #EBEBEB;
    border-color: #EBEBEB;

  }
  .card-body .card-expand {
      width: 8%;
      justify-content: center;
      align-items: flex-end;
      display: flex;
      flex-direction: column;
    background-color: #EBEBEB;
    border-color: #EBEBEB;
  }

  .card-body .card-expand a {
    margin-right: 0px;        
    width: 100%;
    height: 100%;
    color: black;
    position: relative;
  }
  .card-body .card-expand a svg {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transition: all .3s ease-out;
    -o-transition: all .3s ease-out;
    transition: all .3s ease-out;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    -o-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);    
  }  
  .card-body .card-expand a.collapse-show {
      -webkit-transform: unset;
      -ms-transform: unset;
      -o-transform:  unset;
      transform: unset;    
  } 
  .card-body .card-expand a.collapse-show svg{
    -webkit-transform: translate(-50%,-50%) rotate(90deg);
    -ms-transform: translate(-50%,-50%) rotate(90deg);
    -o-transform:  translate(-50%,-50%) rotate(90deg);
    transform: translate(-50%,-50%) rotate(90deg);    
  }
  .card-expanded-details.collapse.show {
    padding:25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BookingOrganizationsInvoice.vue